export const environment = {
  municipio: '',
  production: true,
  isETopocartDev: false,
  isETopocartProd: false,
  isPortoVelho: true,
  isTopocart: false,
  isTopocartDev: false,
  isAlexania: false,
  isManaus: false,

  googleMapsKey: 'AIzaSyDa_RGUAd9-34P9bgA4181u_TPurVM-5FE',
  googleMapsAPI: 'https://maps.googleapis.com/maps/api/',
  /* Para ambientes onPremise é necessário a modificação da chave
  do reCAPTCHA, acesse https://www.google.com/recaptcha/admin
  com uma conta do dominio @topocart.com.br e crie uma chave para o dominio
do tipo v2/checkbox  que sera realizado o deploy */
  captchaKey: '6Lea54kpAAAAANda_edNp3kvEmUqrLIvwWHLzdwj',
  googleGeoCodeAPI: 'https://maps.googleapis.com/maps/api/geocode/json',
  reportsUrl: 'https://relatorios-v2-geo360.portovelho.ro.gov.br/',
  reportUrl: 'https://relatorios-v2-geo360.portovelho.ro.gov.br/',

  visualizador360BaseUrl: 'https://visualizador360-geo360.portovelho.ro.gov.br',
  apiUrl: 'https://plataforma-geo360.portovelho.ro.gov.br/',
  conversorUrl: 'https://conversor-geo360.portovelho.ro.gov.br/',
  apiDjangoUrl: 'https://plataforma-geo360.portovelho.ro.gov.br/django/',
  apiUrlPostgrest: `https://gateway-geo360.portovelho.ro.gov.br/rest`,
  apiUrlGenericPostgrest: `https://gateway-geo360.portovelho.ro.gov.br/plataforma/rest`,
  apiUrlGenericPGTiles: `https://gateway-geo360.portovelho.ro.gov.br/plataforma/tiles/`,
  apiUrlPGTiles: `https://gateway-geo360.portovelho.ro.gov.br/tiles/`,
  apiDjangoDirectUrl: 'https://cadastro-geo360.portovelho.ro.gov.br/',
  djangoDirectUrlToken: 'Bearer 594e84d1-d21b-42e7-9745-bacf8b7b29d2',
  apiAttributesTable: 'https://tabela-atributos-geo360.portovelho.ro.gov.br/',
  postgRestUrl: 'https://gateway-geo360.portovelho.ro.gov.br/rest',
  pgtilesUrl: 'https://gateway-geo360.portovelho.ro.gov.br/tiles/',
  caracterizacaoUrl: 'https://caracterizacao-geo360.portovelho.ro.gov.br',
  reportV2Url: 'https://relatorios-v2-geo360.portovelho.ro.gov.br/',

  openRestUrl: 'https://openrest.desenvolvimento.geo360.topocart.dev.br/',


  apiCNAE:
    'https://cnae.criciuma.apps.etopocart.com/',

  // apiUrl: 'https://api4.webgeo.io/' /* API Oficial */,
  geoServerUrl: 'https://mapsrv2.webgeo.io/geoserver/',
  // apiUrl: 'https://staging-api.webgeo.io/' /* API Staging */,
  geoServerWFSUrl:
    'https://mapsrv2.webgeo.io/geoserver/wfs' /* GeoServer WFS */,
  photonApi: 'https://photon.komoot.de/api/' /* Photon API */,
  firebase: {
    apiKey: 'AIzaSyD4riPTBVU39qjL336AjXfdroCJwNUwQvg',
    authDomain: 'webgeo-test.firebaseapp.com',
    databaseURL: 'https://webgeo-test.firebaseio.com',
    projectId: 'webgeo-test',
    storageBucket: 'webgeo-test.appspot.com',
    messagingSenderId: '358703366933',
    appId: '1:358703366933:web:27b8be17ee90f30ba35f1c',
  },
  recaptchaKey: '6Lea54kpAAAAANda_edNp3kvEmUqrLIvwWHLzdwj',
  mapboxToken:
    'pk.eyJ1Ijoidm0ybWFwYm94IiwiYSI6ImNrbTF6MTYzczB6aGYybnIzcDY0eW9vb2sifQ.J9ErWF5EO5w3oLqGjzqi_w',
  apiGatewayUrl: 'https://api-gateway.geo360.com.br/',
};
